import * as React from 'react';
import { SVGProps } from 'react';

const SvgWorkspaceProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#workspaceProfile_svg__a)' stroke='#000'>
      <path d='M8.5 7v-.5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H17' />
      <rect x={4.5} y={8.5} width={11} height={11} rx={1.5} />
    </g>
    <defs>
      <clipPath id='workspaceProfile_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgWorkspaceProfile;
